// extracted by mini-css-extract-plugin
export default {"ourTeamSection":"ourTeamSection_ourTeamSection__djxAl","textWrap":"ourTeamSection_textWrap__BHKm5","teamWrap":"ourTeamSection_teamWrap__igp-a"};